import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fieldWorkApi } from '../../api/field-work-api';
import { isOpenStatus, type FieldWorkRequest } from '../../domain/fieldWorkRequest';

/** Open (not completed or rejected) field work requests per site id. */
export function countOpenRequestsBySite(requests: FieldWorkRequest[]): Map<string, number> {
  const counts = new Map<string, number>();
  for (const request of requests) {
    if (!request.siteId || !isOpenStatus(request.status)) continue;
    counts.set(request.siteId, (counts.get(request.siteId) ?? 0) + 1);
  }
  return counts;
}

/** Open field work per site, from the shared field work query. */
export function useOpenRequestCountsBySite(): ReadonlyMap<string, number> {
  const fieldWork = useQuery({
    queryKey: ['field-work'],
    queryFn: () => fieldWorkApi.listFieldWork(),
  });
  return useMemo(() => countOpenRequestsBySite(fieldWork.data ?? []), [fieldWork.data]);
}
